import { redirect } from 'react-router-dom'

import { fetchHomePage, fetchSingle } from '@/api'

const decodeTitle = (title) => {
  const txt = document.createElement('textarea')
  txt.innerHTML = title
  return txt.value
}

export const routerGuard = async ({ routeData = {}, type = null, homePage = false }) => {
  const request = {
    type: type,
    params: {
      slug: routeData.params.slug,
    },
  }
  if (homePage) {
    const data = await fetchHomePage()
    document.title = `${window.__REACT_WORDPRESS__.state.site.name} | ${window.__REACT_WORDPRESS__.state.site.description}`
    return data.data.data.modules
  } else if (type === 'events' || type === 'news' || type === 'release') {
    const data = await fetchSingle(request)
    if (data.data.length === 0) return redirect('/404')
    document.title = `${decodeTitle(data.data[0].title.rendered)} | ${
      window.__REACT_WORDPRESS__.state.site.description
    }`
    return data.data[0]
  } else if (type === 'pages') {
    const data = await fetchSingle(request)
    if (data.data.length === 0) return redirect('/404')
    document.title = `${decodeTitle(data.data[0].title.rendered)} | ${
      window.__REACT_WORDPRESS__.state.site.description
    }`
    return data.data[0]?.acf?.modules
  } else {
    if (type === null) return routeData.params
    const data = await fetchSingle(request)
    if (data.data.length === 0) return redirect('/404')
    document.title = `${data.data[0].title.rendered} | ${window.__REACT_WORDPRESS__.state.site.description}`
    return data.data[0]
  }
}
